import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { Suspense } from "react";
import {
  auditLogFilterOptionsQueryOptions,
  auditLogsQueryOptions,
} from "@/app/audit-logs/api/get-audit-logs";
import { AuditLogsSkeleton } from "@/app/audit-logs/components/audit-logs-skeleton";
import { AuditLogsList } from "@/app/audit-logs/list";
import {
  auditLogsSearchDefaults,
  auditLogsSearchSchema,
  pickFilters,
} from "@/app/audit-logs/search";
import { PROJECT } from "@/app/capabilities/permissions";
import { RouteErrorBoundary } from "@/components/custom/router/route-error-boundary";
import { requireProjectPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/audit-logs"
)({
  validateSearch: auditLogsSearchSchema,
  search: {
    middlewares: [stripSearchParams(auditLogsSearchDefaults)],
  },
  errorComponent: RouteErrorBoundary,
  component: () => (
    <Suspense fallback={<AuditLogsSkeleton />}>
      <AuditLogsList />
    </Suspense>
  ),
  loaderDeps: ({ search }) => ({
    filters: pickFilters(search),
    limit: search.limit,
    offset: search.offset,
  }),
  beforeLoad: (ctx) => requireProjectPermission(ctx, PROJECT.auditLogs.read),
  loader: ({ context: { queryClient }, params, deps }) => {
    queryClient.prefetchQuery(
      auditLogsQueryOptions({
        scope: params,
        filters: deps.filters,
        limit: deps.limit,
        offset: deps.offset,
      })
    );
    queryClient.prefetchQuery(
      auditLogFilterOptionsQueryOptions({
        scope: params,
        filters: deps.filters,
      })
    );
    return { crumb: "Audit Logs" };
  },
});
